import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {subscribe} from 'dna-react-ioc'

import {RouterStore, RouterStoreSymbol} from './RouterStore'
import {COMPANY_NAME} from '@/constants/app'
import {PaymentMethodType} from '@/constants'
import {ROUTES} from './routes'
export const getRouterStore = () => {
    return subscribe<RouterStore>(RouterStoreSymbol)
}

export const withTitle = (Component: React.ComponentType<any>, title?: string) => {
    // eslint-disable-next-line react/display-name
    return (props: any) => {
        const {t} = useTranslation()
        useEffect(() => {
            const _title = title ? t(title) + ' | ' : ''
            document.title = _title + t('globals:siteTitle', {companyName: COMPANY_NAME})
        }, [])

        return <Component {...props} />
    }
}

export const getPaymentMethodDetailsRoute = (type: PaymentMethodType) => {
    return ROUTES.settings.paymentMethodDetails.replace(':type', type)
}
